import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Modal from 'react-modal';
import ApiResult from 'admin/components/shared/ApiResult';
import Button from 'admin/components/shared/Button';
import { createKioskRemoteInstruction } from 'admin/actions/devices';
import { openAlertModal } from 'admin/actions/alert-modal';
import { getErrorMessageJp } from 'admin/utils';
import styles from './styles.scss';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
};

class RemoteInstruction extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isError: false,
      apiResult: '',
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  onClick = (e) => {
    const content = e.currentTarget.getAttribute('data-content');
    const isForced = e.currentTarget.getAttribute('data-is-forced').toLowerCase() === 'true';
    if (isForced) {
      this.props.openAlertModal({
        body: <div>端末で取引中の場合、取引は強制終了されます。本当に実行しますか？</div>,
        onConfirm: () => {
          this.kioskRemoteInstruction(content);
        },
      });
    } else {
      this.kioskRemoteInstruction(content);
    }
  }

  kioskRemoteInstruction(content) {
    this.closeModal();
    const resultMessage = `${content}を設定しました`;
    const postData = { kiosk_id: this.props.kioskId, content };
    this.props.createKioskRemoteInstruction(postData).then((response) => {
      if (response.ok) {
        this.setState({
          apiResult: resultMessage,
          isError: false,
        });
      } else {
        response.json().then((json) => {
          this.setState({
            apiResult: getErrorMessageJp(json.type),
            isError: true,
          });
        });
      }
    });
    this.flashApiResult();
  }

  openModal() {
    this.setState({ isModalOpen: true });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  flashApiResult() {
    setTimeout(() => this.setState({ apiResult: '' }), 6000);
  }

  render() {
    return (
      <div>
        <ApiResult
          message={this.state.apiResult}
          isError={this.state.isError}
        />
        <div styleName="buttons">
          <Button color="normal" onClick={this.openModal}>リモート操作</Button>
        </div>
        <br />
        <Modal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick
          closeTimeoutMS={200}
          ariaHideApp={false}
          style={modalStyles}
        >
          <div styleName="headline">リモート操作</div>
          <Button onClick={this.onClick} data-content="GO_INTO_SERVICE" data-is-forced="false">サービス開始</Button>
          <br /><br />
          <div >通常実行</div>
          <div styleName="buttons">
            <Button onClick={this.onClick} data-content="GO_OUT_OF_SERVICE_LATER" data-is-forced="false">サービス停止</Button>
            <Button onClick={this.onClick} data-content="MACHINE_RESTART_LATER" data-is-forced="false">マシン再起動</Button>
            <Button onClick={this.onClick} data-content="MACHINE_SHUTDOWN_LATER" data-is-forced="false">マシンシャットダウン</Button>
          </div>
          <br /><br />
          <div styleName="WarningText">強制実行</div>
          <div styleName="WarningText">（注意：取引中の場合、取引は強制終了されます）</div>
          <div styleName="buttons">
            <Button onClick={this.onClick} data-content="GO_OUT_OF_SERVICE_NOW" data-is-forced="true" color="danger">サービス停止</Button>
            <Button onClick={this.onClick} data-content="MACHINE_RESTART_NOW" data-is-forced="true" color="danger">マシン再起動</Button>
            <Button onClick={this.onClick} data-content="MACHINE_SHUTDOWN_NOW" data-is-forced="true" color="danger">マシンシャットダウン</Button>
          </div>
        </Modal>
      </div>
    );
  }
}

RemoteInstruction.defaultProps = {
  createKioskRemoteInstruction: PropTypes.func,
  openAlertModal: PropTypes.func,
  kioskId: PropTypes.number,
};

RemoteInstruction.propTypes = {
  createKioskRemoteInstruction: PropTypes.func,
  openAlertModal: PropTypes.func,
  kioskId: PropTypes.number,
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => bindActionCreators({
  createKioskRemoteInstruction,
  openAlertModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(RemoteInstruction, styles));
